import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
import { checkStatus, getHeaders } from "../../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL;


// For Get Ticket  List  Data.
export async function getOpenSummaryListData(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Report/Request/OpenSummary`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export async function getClosedSummaryListData(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Report/Request/ClosedSummary`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getEmployeeMissingListData(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Report/Profile/MissingAttributes`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export async function getLeaveBalanceListData(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Report/DayOff/LeaveAndWFHBalance`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getEmployeesLeaves = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/Report/DayOff/LeaveSummary`, params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


  export const getYearlyWFHApplied = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/Report/DayOff/WFHSummary`, params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

    export const getReportCategories = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/Report/Categories`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

    export const getReport = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/Report/List`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }